import template from '../../../ui-formly/partials/form.html'
import FormControllerFactory from '../../../ui-formly/controllers/FormControllerFactory'
import formly from './formly'
import asyncValidators from '../../validation/asyncValidators/index'
import server from '../../server/index'

import { vsName as ServerUtilityName } from '../../../records/server/serverUtility'

import { forEach, set } from 'lodash'

usersEdit.vsName = 'usersEdit'
usersEdit.vsNgType = 'directive'

usersEdit.$inject = [server.vsName, asyncValidators.vsName, ServerUtilityName, "$q"]
function usersEdit(server, asyncValidators, serverUtility, $q) {
  return {
    templateUrl: template,
    transclude: false,
    restrict: 'E',
    scope: {
      model: '=?'
    },
    controller: FormControllerFactory({
      returnState: '^.grid',
      formFields: formly(asyncValidators),
      submit: userModel => {
        return server.userSave(userModel).then(userResult =>{
          const userAuthId = userResult.UserAuthId
          const userPropertyIds = userModel.PropertyIds
          return serverUtility.post({
            url: "/api/user/properties",
            postObject: {
              UserAuthId: userAuthId,
              PropertyIds: userPropertyIds
            }
          })
        })
      } ,
      initialize: function () {
        const { model, options } = this

        const allPropertiesPromise = serverUtility.fetchAll({
          url: "/api/properties",
          query: { OrderBy: "Name"}
        })
        const userPropertiesPromise = (model.UserAuthId ? serverUtility.fetchAll({
          url: "/api/user/properties",
          query: { UserAuthId: model.UserAuthId }
        }) : $q.when([])).then(userProperties => {
          model.PropertyIds = userProperties.map(up => up.PropertyId)
          return userProperties
        })

        $q.all([allPropertiesPromise, userPropertiesPromise]).then(promiseResults =>{
          const [allPropertiesResult, userPropertiesResult] = promiseResults

          const userProperties = userPropertiesResult
          const allProperties = allPropertiesResult
          forEach(allProperties, property =>{
            property.selected = Boolean(userProperties.find(up => up.PropertyId === property.Id))
          })
          set(options, 'formState.properties', allProperties)
        })
      }
    }),
    controllerAs: 'ctrl',
    bindToController: true
  }
}

export default usersEdit
